import React from "react";
import LibraryParity from "./LibraryParity";
export default function Books() { return <LibraryParity kind="books" />; }
